<div class="size-full flex items-center justify-center">
  <ng-template #indicatorTemplate><span nz-icon nzType="loading" class="text-5xl"></span></ng-template>
  <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
</div>
